
export default function () {
  const orderSignFormList = [
    {
      el: 'input',
      itemConfig: {
        label: '业务合同编号',
        prop: 'contractNo',
      },
      elConfig: {
        events: {

        },
      },
    },
    {
      el: 'date-picker',
      itemConfig: {
        label: '合同起止日期',
        prop: 'contractDate',
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '合同附件',
        prop: 'contractAttachment',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'text',
        fileList: [],
        limit: 20,
        sizeType: 4,
        commonUpload: true,
        group: 'order',
        code: 'order_contract_attachment_file',
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '租赁车辆数',
        prop: 'carTotalNum',
      },
      directives: [{ name: 'number', arg: 'integer', value: 18 }],
    },
  ]

  const orderSignRules = {
    contractNo: [
      {
        required: true,
        message: '合同编号不能为空',
        trigger: 'change',
      },
    ],
    contractAttachment: [
      {
        required: true,
        message: '合同附件不能为空',
        trigger: 'change',
      },
    ],
  }
  // 预览数据
  const orderSignPreviewList = [
    {
      el: 'text',
      itemConfig: {
        label: '所属公司',
        prop: 'companyName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'rentCalculationRules',
        value: '企业客户',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
        width: 110,
      },
    },
  ]
  const orderSignModel = {}
  return {
    orderSignFormList,
    orderSignRules,
    orderSignModel,
    orderSignPreviewList,
  }
}
